import RequestService from "@/configurations/AxiosConfig";
import { IRoute } from "@/types/type";

const endpoints = {
  routes: 'routes',
  routesByCompanyId: 'routes/byCompanyId',
  delete: 'routes/delete',
};

const RoutesService = {
  getAllRoutes: async () => RequestService.get(endpoints.routes),
  getRoutesByCompanyId: async (companyId: string | number) => RequestService.get(`${endpoints.routesByCompanyId}/${companyId}`),
  createRoutes: (data: any) => RequestService.post(endpoints.routes, data),
  updateRoutes: async (id: string | number, data: IRoute) => RequestService.patch(`${endpoints.routes}/${id}`, data),
  deleteRoute: async (id: string | number) => RequestService.patch(`${endpoints.delete}/${id}`),
};

export default RoutesService;
